export const GET_CUSTOMER_START = "GET_CUSTOMER_START"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_CUSTOMER_ERROR = "GET_CUSTOMER_ERROR"

export const SEARCH_CUSTOMER = "SEARCH_CUSTOMER"